
<template>
<b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
  <div class="body-wrapper">
    <nav-bar />
    <b-container class="position-relative strata-table contacts" fluid>
      <div class="main-panel">
        <div class="db-content-wrapper">
          <div class="mb-2 cts-header">
            <h4 class="page-title my-4">My Contacts</h4>
            <b-button variant="primary" :to="{ name: 'my-contacts' }"
              >My Contacts</b-button>
          </div>
          <b-row>
            <b-col lg="6" md="12">
              <div class="d-flex mb-3">
                <router-link
                  :to="{ name: 'manager-contacts-contractors' }"
                  :style="{ color: '$primary', padding: '5px' }"
                >
                  <h1
                    class="table-title"
                    style="display: inline; font-weight: bold"
                  >
                    Contractor
                  </h1>
                </router-link>
                <span style="font-size: 19px; position: relative">/</span>
                <router-link
                  :to="{ name: 'manager-contacts-building-managers' }"
                  :style="{ color: 'grey', padding: '5px' }"
                >
                  <h1 class="table-title" style="display: inline">
                    Building Manager
                  </h1>
                </router-link>
              </div>
            </b-col>

            <b-col lg="6" md="12">
              <b-row style="row-gap: 10px;">
                <b-col cols="12" sm="6" md="6">
                  <b-form @submit.prevent class="align-items-start">
                    <label class="sr-only" for="filterTraderTypes"
                      >Trader Types</label
                    >
                    <treeselect
                      id="filterTraderTypes"
                      v-model="filterTraderTypes"
                      :multiple="true"
                      :options="traderTypeOptions"
                      placeholder="Trade Type"
                      :style="{ width: '100%' }"
                      @input="filter(1)"
                    />
                  </b-form>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="6">
                  <div class="position-relative f-b">
                    <i class="fas fa-search search-icon"></i>
                    <b-form-input
                      class="mb-2 mb-sm-0"
                      placeholder=""
                      v-model="filterQuery"
                      @change="filter(1)"
                    ></b-form-input>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <div class="d-flex mt-4 table-btns">
            <h5 style="font-weight: bold; margin-top: 10px">
              {{ selectedContractors.length }}
              <span>Contractor(s)</span> Selected
            </h5>
            <b-button
              v-b-modal.modal-center
              variant="primary"
              class="mr-2 adjust"
              :disabled="
                selectedContractors.length > 1 ||
                selectedContractors.length == 0
              "
              @click="inviteWorkOrderModal()"
              >Invite to Work Order</b-button
            >
            <b-button
              v-b-modal.modal-center
              variant="outline-primary adjust"
              :disabled="selectedContractors.length == 0"
              @click="inviteQuoteModal()"
              >Invite to Quote</b-button
            >

            <div>
              <b-modal
                id="modal-center"
                centered
                title="Invite for quotes"
                :hide-footer="true"
                :hide-header="false"
                :style="{ padding: '6px' }"
                v-if="showInviteQuoteModal"
              >

                <div class="">
                  <p style="color: black; font-weight: bold">
                    {{ selectedContractors.length }}
                    <span v-if="selectedContractors.length > 1"
                      >Contractors</span
                    ><span v-else>Contractor</span> Selected
                  </p>
                  <p style="color: black">Select Quote</p>
                  <treeselect
                    :multiple="false"
                    :options="quoteOption"
                    placeholder="Select Quote"
                    v-model="selectedQuote"
                    :style="{ width: '100%' }"
                    @input="handledSelectQuote()"
                  />
                  <br />
                  <div
                    v-if="
                      Object.keys(quoteInfo).length > 0 && selectedQuote != null
                    "
                  >
                    <label style="font-weight: bold">Date: </label>&nbsp;<span
                      >{{ quoteInfo.issue_date }}</span
                    ><br />
                    <label style="font-weight: bold">Due Date: </label
                    >&nbsp;<span>{{ quoteInfo.due_date }}</span
                    ><br />
                    <label style="font-weight: bold">Strata Plan Id: </label
                    >&nbsp;<span>{{
                      quoteInfo.strata_plan.strata_plan_number
                    }}</span
                    ><br />
                    <label style="font-weight: bold">Address: </label
                    >&nbsp;<span v-if="quoteInfo.strata_plan.building != null"
                      >{{ quoteInfo.strata_plan.building }},</span
                    ><span
                      >{{ quoteInfo.strata_plan.street }},
                      {{ quoteInfo.strata_plan.suburb }},
                      {{ quoteInfo.strata_plan.state }},
                      {{ quoteInfo.strata_plan.postcode }}</span
                    ><br />
                    <label style="font-weight: bold">Manager Name: </label
                    >&nbsp;<span
                      >{{ quoteInfo.strata_plan.manager.first_name }}
                      {{ quoteInfo.strata_plan.manager.last_name }}</span
                    ><br />
                  </div>

                  <div style="margin-top: 20px" class="d-flex justify-content-between quote-btns">
                    <b-button
                      variant="primary"
                      :to="{
                        name: 'manager-quote-edit',
                        params: { id: 'new', step: 1 },
                        query: { selected_contractors_id: selectedContractors },
                      }"
                      >Create New Quote</b-button
                    >
                    <b-button
                      data-dismiss="modal"
                      variant="primary"
                      @click="inviteContractors(selectedQuote, 'quote')"
                      >Invite Now</b-button
                    >
                  </div>
                  <br />
                </div>
              </b-modal>
            </div>

            <div>
              <b-modal
                id="modal-center"
                size="md"
                class="workorder-modal"
                centered
                title="Invite for Work Order"
                :hide-footer="true"
                :hide-header="false"
                :style="{ padding: '6px' }"
                v-if="showInviteWorkOrderModal"
              >

                <div class="">
                  <p style="color: black; font-weight: bold">
                    {{ selectedContractors.length }}
                    <span v-if="selectedContractors.length > 1"
                      >Contractors</span
                    ><span v-else>Contractor</span> Selected
                  </p>
                  <p style="color: black">Select Work Orders</p>
                  <treeselect
                    :multiple="false"
                    :options="workOrderOption"
                    placeholder="Select Quote"
                    v-model="selectedWorkOrder"
                    :style="{ width: '100%' }"
                    @input="handledSelectWorkOrder()"
                  />
                  <br />
                  <div
                    v-if="
                      Object.keys(workOrderInfo).length > 0 &&
                      selectedWorkOrder != null
                    "
                  >
                    <label style="font-weight: bold">Date: </label>&nbsp;<span
                      >{{ workOrderInfo.issue_date }}</span
                    ><br />
                    <label style="font-weight: bold">Due Date: </label
                    >&nbsp;<span>{{ workOrderInfo.due_date }}</span
                    ><br />
                    <label style="font-weight: bold">Strata Plan Id: </label
                    >&nbsp;<span>{{
                      workOrderInfo.strata_plan.strata_plan_number
                    }}</span
                    ><br />
                    <label style="font-weight: bold">Address: </label
                    >&nbsp;<span
                      v-if="workOrderInfo.strata_plan.building != null"
                      >{{ workOrderInfo.strata_plan.building }},</span
                    ><span
                      >{{ workOrderInfo.strata_plan.street }},
                      {{ workOrderInfo.strata_plan.suburb }},
                      {{ workOrderInfo.strata_plan.state }},
                      {{ workOrderInfo.strata_plan.postcode }}</span
                    ><br />
                    <label style="font-weight: bold">Manager Name: </label
                    >&nbsp;<span
                      >{{ workOrderInfo.strata_plan.manager.first_name }}
                      {{ workOrderInfo.strata_plan.manager.last_name }}</span
                    ><br />
                  </div>

                  <div
                    style="margin-top: 20px"
                    class="d-flex justify-content-between work-order-btns"
                  >
                    <b-button
                      variant="primary"
                      :to="{
                        name: 'manager-workorder-edit',
                        params: { id: 'new', step: 1 },
                        query: { selected_contractors_id: selectedContractors },
                      }"
                      >Create New Work Order</b-button
                    >
                    <b-button
                      data-dismiss="modal"
                      variant="primary"
                      @click="
                        inviteContractors(selectedWorkOrder, 'work-order')
                      "
                      >Invite Now</b-button
                    >
                  </div>
                  <br />
                </div>
              </b-modal>
            </div>
          </div>

          <div class="datagrid mb-4 mt-5">
            <div class="datagrid-body">
              <b-table
                :busy="this.$root.loading"
                :items="tableItems"
                :fields="tableFields"
                sort-icon-left
                hover
                responsive
                show-empty
                :tbody-tr-class="rowClass"
              >
                <template v-slot:cell(status)="row">
                  <p
                    v-if="row.item.status == 'open'"
                    style="
                      background-color: rgb(137 206 61);
                      display: inline-block;
                      padding: 3px 6px;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    Open
                  </p>

                  <p
                    v-if="row.item.status == 'active'"
                    style="
                      background-color: #4682b4;
                      display: inline-block;
                      padding: 3px 6px;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    Active
                  </p>

                  <p
                    v-if="row.item.status == 'pending-approval'"
                    style="
                      background-color: #4682b4;
                      display: inline-block;
                      padding: 3px 6px;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    Pending Approval
                  </p>

                  <p
                    v-if="row.item.status == 'due'"
                    style="
                      background-color: #4682b4;
                      display: inline-block;
                      padding: 3px 6px;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    Due Soon {{ "(" + row.item.remaningdays + " Days left)" }}
                  </p>

                  <p
                    v-if="row.item.status == 'over-due'"
                    style="
                      background-color: rgb(180 70 70);
                      display: inline-block;
                      padding: 3px 6px;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    Overdue {{ "(" + row.item.remaningdays + " Days Passed)" }}
                  </p>

                  <p
                    v-if="row.item.status == 'draft'"
                    style="
                      background-color: rgb(216 195 43);
                      display: inline-block;
                      padding: 3px 6px;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    Draft Quote
                  </p>

                  <p
                    v-if="row.item.status == 'completed'"
                    style="
                      background-color: rgb(207 14 201);
                      display: inline-block;
                      padding: 3px 6px;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    Completed Quote
                  </p>
                </template>

                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner
                      class="align-middle"
                      :variant="'primary'"
                    ></b-spinner>
                  </div>
                </template>

                <template v-slot:cell(Favourite)="row">
                  <div class="favoriting">
                    <div>
                    <label
                      class="favorite__heart"
                      v-bind:class="{
                        favorite__heart__selected:
                          favorite_business_list.includes(row.item.businessId),
                      }"
                    >
                      <input
                        class="favorite__checkbox"
                        :id="row.item.businessId"
                        type="checkbox"
                        v-bind:value="row.item.businessId"
                        @click="favorite(row.item.businessId, $event)"
                      />
                      ★
                    </label>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(TradeType)="row" >
                    <inner_content :data="row.item.trade_type"/>
                </template>
                <template v-slot:cell(Compliant)="row">
                  <i
                    v-if="row.item.Compliant && row.item.Status=='expired'"
                    class="fas fa-check-circle"
                    style="font-size: 20px; color: rgb(255, 234, 0)"
                  ></i>
                  <i
                    v-else-if="row.item.Compliant && row.item.Status=='verified'"
                    class="fas fa-check-circle"
                    style="font-size: 20px; color: rgb(0, 186, 136)"
                  ></i>
                  <i
                    v-else-if="row.item.Compliant && row.item.Status=='blocked'"
                    class="fas fa-check-circle"
                    style="font-size: 20px; color: rgb(255, 87, 51)"
                  ></i>
                  <i
                    v-else-if="row.item.Compliant && row.item.Status=='hide'"
                    class="fas fa-check-circle"
                    style="display:none;"
                  ></i>
                  <i
                    v-else
                    class="fas fa-times-circle"
                    style="font-size: 20px; color: rgb(237, 46, 126)"
                  ></i>

                </template>
                <template v-slot:cell(Action)="row">
                  <div style="display: flex" v-if="row.item.Status!='hide'">
                    <b-form-checkbox
                      v-model="selectedContractors"
                      :id="'id' + row.item.id"
                      :value="row.item.id"
                    >
                    </b-form-checkbox>
                    <router-link
                      :to="{
                        name: 'manager-contacts-contractors-view',
                        params: { id: row.item.id },
                      }"
                      >View Details
                    </router-link>
                  </div>
                </template>
                <template #empty class="text-center"> No Data Found </template>
              </b-table>
            </div>
            <div class="datagrid-footer" v-if="lastPage > 1">
              <b-pagination
                pills
                align="right"
                :total-rows="total"
                v-model="currentPage"
                :page-count="lastPage"
                :per-page="perPage"
                :hide-goto-end-buttons="true"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    <footer-component></footer-component>
    </b-container>

  </div>
  </b-overlay>
</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import _ from "lodash";
import moment from "moment";
import FooterComponent from "../../../includes/FooterComponent.vue";
import { Treeselect, ASYNC_SEARCH } from "@riophae/vue-treeselect";
import Swal from "sweetalert2";
import inner_content from '@frontend/pages/manager/contacts/Contractors/view/inner_content_tag.vue';

export default {
  components: {
    NavBar,
    FooterComponent,
    Treeselect,
    inner_content
  },
  props: {
    filterStatus: String,
  },
  data() {
    return {
      currentPage: 1,
      total: 0,
      perPage: 50,
      lastPage: 1,
      tableItems: [],
      tableFields: [
        { key: "", sortable: true },
        {
          key: "Favourite",
          sortable: true,
          class: "favourite-th",
          thStyle: { visibility: "visible" },
        },
        { key: "Company", sortable: true },
        { key: "Name", sortable: true },
        { key: "TradeType", sortable: true, class: "table-td-width" },
        { key: "WorkHistory", sortable: true },
        { key: "CompletedJob", sortable: true },
        { key: "Compliant", sortable: true },
        { key: "LastActive", sortable: true},
        { key: "Action", sortable: false },
      ],
      filterQuery: "",
      filterTraderTypes: null,
      traderTypeOptions: [],
      tradeType: [],
      selectedContractors: [],
      selectedQuote: null,
      quoteOption: [],
      quoteInfo: {},
      workOrderOption: [],
      selectedWorkOrder: null,
      workOrderInfo: {},
      showInviteQuoteModal: false,
      showInviteWorkOrderModal: false,

      //For Favourite
      value: false,
      favorite_business_list: [],
    };
  },
  mounted() {
    this.loadCategories();
    this.filter(1);
  },
  methods: {
    rowClass(item) {
        if (item.Status == 'hide') return 'table-secondary'
    },
    loadCategories() {
      axios
        .post("api/content/getBusinessCategories", { load_children: 1 })
        .then((response) => {
          this.traderTypeOptions = response.data.categories.map((category) => {
            if (category.children.length > 0) {
              return {
                id: category.id,
                label: category.name,
                children: category.children.map((children) => {
                  return {
                    id: children.id,
                    label: children.name,
                  };
                }),
              };
            } else {
              return {
                id: category.id,
                label: category.name,
              };
            }
          });
        });
    },
    filter(page = 1) {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/manager/contacts/contractor/filter", {
          page: page,
          per_page: 20,
          filter_query: this.filterQuery,
          filterTraderTypes: this.filterTraderTypes,
          // filter_status: this.filterStatus,
        })
        .then((response) => {
          this.currentPage = response.data.current_page;
          this.total = response.data.total;
          this.perPage = response.data.per_page;
          this.lastPage = response.data.last_page;
          this.tableItems = _.map(
            response.data.contractors,
            function (contractor) {
              let company = "";
              let tradeType = [];
              let status= 'verified';
              let current_date= new Date().getTime();
              let passed_days= 0;

                contractor.active_business.licenses.forEach((license)=>{

                    if(license.expiry_date){
                        if(status!='blocked' && status!='expired' && status!='hide'){
                        let remaining_days=  Math.ceil((new Date(license.expiry_date).getTime()- current_date)/ (1000 * 3600 * 24)) ;
                        if(remaining_days<= 0){
                            passed_days= Math.ceil((current_date - new Date(license.expiry_date).getTime())/ (1000 * 3600 * 24));
                            if(passed_days <= 15){
                                status= 'blocked'
                            }
                            else{
                                status= 'hide'
                            }
                        }
                        else if(remaining_days<=7 && remaining_days>=0 ){
                            status= 'expired';
                        }
                    }

                    }



                })

              if(status!='blocked' && status!='expired' && status!='hide'){

                contractor.active_business.insurances.forEach((license)=>{

                        if(status!='blocked' && status!='expired'){
                        let remaining_days=  Math.ceil((new Date(license.insurance_expiry).getTime()- current_date)/ (1000 * 3600 * 24)) ;
                        console.log(remaining_days);
                        if(remaining_days<= 0){
                            passed_days= Math.ceil((current_date - new Date(license.insurance_expiry).getTime())/ (1000 * 3600 * 24));
                            if(passed_days <= 15){
                                status= 'blocked'
                            }
                            else{
                                status= 'hide'
                            }
                        }
                        else if(remaining_days<=7 && remaining_days>=0 ){
                            status= 'expired';
                        }
                    }



                })

            }

              if (contractor.active_business) {
                company = contractor.active_business.company_name;
                _.each(contractor.active_business.categories, (category) => {
                  tradeType.push({
                    trade_type: category.name,
                  });
                });
              }

              return {
                id: contractor.id,
                businessId: contractor.active_business.id,
                Company: company,
                Name: contractor.first_name + " " + contractor.last_name,
                trade_type: tradeType,
                WorkHistory: contractor.work_history,
                CompletedJob: contractor.work_completed,
                Compliant: contractor.active_business.compliant,
                LastActive: contractor.last_active_at
                  ? moment(contractor.last_active_at)
                      .subtract(4, "hours")
                      .subtract(15, "minutes")
                      .fromNow()
                  : "Not Logged In",
                Action: "",
                Status: status
              };
            }
          );
          // contractor.last_active_at? moment(contractor.last_active_at).fromNow() : 'Not login unit now'
          //For Favourite Business
          this.favorite_business_list = _.map(
            response.data["favourite_business_list"].favourite_business,
            function (business) {
              return business.id;
            }
          );
          this.$root.$data.bsLoader = false;
          }).catch((err) => {
            this.$root.$data.bsLoader = false;
          });
    },
    loadQuotes() {
      axios
        .post("api/manager/contacts/contractor/loadQuotes", {
          load_work_order: 0,
          load_quote: 1,
        })
        .then((response) => {
          this.quoteOption = response.data.quotes.map((quote) => {
            if (
              quote.status_parsed == "open" ||
              quote.status_parsed == "active" ||
              quote.status_parsed == "due"
            ) {
              return {
                id: quote.id,
                label: quote.organization_id,
              };
            }
          });
        });
    },
    loadWorkOrders() {
      axios
        .post("api/manager/contacts/contractor/loadQuotes", {
          load_work_order: 1,
          load_quote: 0,
        })
        .then((response) => {
          this.workOrderOption = response.data.quotes.map((quote) => {
            if (
              quote.status_parsed == "open" ||
              quote.status_parsed == "active" ||
              quote.status_parsed == "due"
            ) {
              return {
                id: quote.id,
                label: quote.organization_id,
              };
            }
          });
        });
    },
    handledSelectQuote() {
      axios
        .post("api/manager/contacts/contractor/handledSelectQuoteorWorkOrder", {
          quote_id: this.selectedQuote,
        })
        .then((response) => {
          this.quoteInfo = response.data.quote_details;
          this.quoteInfo.issue_date = moment(
            response.data.quote_details.issue_date
          ).format("D MMM YYYY");
          this.quoteInfo.due_date = moment(
            response.data.quote_details.due_date
          ).format("D MMM YYYY");
        });
    },
    handledSelectWorkOrder() {
      axios
        .post("api/manager/contacts/contractor/handledSelectQuoteorWorkOrder", {
          quote_id: this.selectedWorkOrder,
        })
        .then((response) => {
          this.workOrderInfo = response.data.quote_details;
          this.workOrderInfo.issue_date = moment(
            response.data.quote_details.issue_date
          ).format("D MMM YYYY");
          this.workOrderInfo.due_date = moment(
            response.data.quote_details.due_date
          ).format("D MMM YYYY");
        });
    },
    inviteContractors(selectedQuoteorWorkOrder, job_type) {
      axios
        .post("api/manager/contacts/contractor/inviteContractors", {
          job_type: job_type,
          quote_id: selectedQuoteorWorkOrder,
          selected_contractors_id: this.selectedContractors,
        })
        .then((response) => {
          this.showInviteQuoteModal = false;
          this.showInviteWorkOrderModal = false;
          this.selectedQuote = null;
          this.selectedWorkOrder = null;

          if (
            response.data.duplicate_contractors.length ==
            this.selectedContractors.length
          ) {
            Swal.fire({
              text: "Selected Contractor(s) already invited to Quote.",
              icon: "error",
              confirmButtonText: "Ok",
            });
          } else if (response.data.duplicate_contractors.length > 0) {
            //showing success alert
            Swal.fire({
              text: "Only some of the selected Contractor(s) Invited to Quote.",
              icon: "success",
              confirmButtonText: "Ok",
            });
          } else {
            //showing success alert
            Swal.fire({
              text: "Selected Contractor(s) Invited to Quote.",
              icon: "success",
              confirmButtonText: "Ok",
            });
          }
          this.selectedContractors = [];
        });
    },
    favorite(favourite_id, event) {
      if (!this.favorite_business_list.includes(favourite_id)) {
        this.favorite_business_list.push(favourite_id);
      } else {
        this.favorite_business_list.splice(
          this.favorite_business_list.indexOf(favourite_id),
          1
        );
      }

      axios
        .post("api/manager/contacts/contractor/favouriteBusiness", {
          favorite_business_list: this.favorite_business_list,
        })
        .then((response) => {});
    },
    inviteWorkOrderModal() {
      this.loadWorkOrders();
      this.showInviteWorkOrderModal = true;
      this.showInviteQuoteModal = false;
    },
    inviteQuoteModal() {
      this.loadQuotes();
      this.showInviteWorkOrderModal = false;
      this.showInviteQuoteModal = true;
    },
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.filter(value);
      },
    },
  },
};
</script>
<style scoped>
.body-wrapper {
  background-color: #f7f7fc !important;
  min-height: 100vh;
}

.table-btns {
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-end;
}

.work-order-btns,
.quote-btns {
  flex-wrap: wrap;
  gap: 0.5rem;
}

.table .favourite-th {
  color: red !important;
}
.table-td-width {
  max-width: 300px;
}
.modal-body {
  padding: 6px;
}
.btn-sm {
  padding: 0.55rem 1rem;
}
.favorite__heart {
  display: inline-block;
  padding: 3px;
  vertical-align: middle;
  line-height: 1;
  font-size: 20px;
  color: #ababab;
  cursor: pointer;
  -webkit-transition: color 0.2s ease-out;
  transition: color 0.2s ease-out;
}
.vue-treeselect__control {
  padding: 1rem 0.75rem !important;
}
.favorite__heart.is-disabled:hover {
  cursor: default;
}
.favorite__checkbox {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
}
.favorite__heart__selected {
  color: #ffbc00;
}

.cts-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

footer {
    margin-top: 9rem;
    margin-bottom: 1rem;
}
</style>
